export default "__VITE_ASSET__B7_KQKz3__"